import React, {useContext, useEffect, useState} from 'react';
import { UserContext } from '../../Contexts/UserContext';
import { adminService } from '../../Services/adminService';
import RolesEdit from './RolesEdit';

const Roles = () => {
    const [roles, setRoles] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const {user} = useContext(UserContext);

    useEffect(() => {
        refresh();
    }, []);

    const refresh = () => {
        adminService.getRoles(user.originalRegion).then((data) => {
            setRoles(data);
        }).catch((e) => {
            toast.error("Unable to retrieve the roles. Error: " + e);
        });
    };

    const renderRow = (role) => {
        return <tr key={role.name}>
                    <td>{role.name}</td>
                    <td>{role.description}</td>
                </tr>;
    }

    return (
        <div className="form-content">
            <div className="form-head">
                <h3>Roles</h3>
                {
                    user.isSuperAdmin && 
                    <a className="add-link" onClick={() => setShowModal(true)}>+ Add a Role</a>
                }
            </div>
            <div className="admin-table-responsive">
                <table className="table table-style">
                    <thead>
                        <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            roles && 
                            roles.map((config) => renderRow(config))
                        }
                    </tbody>
                </table>
            </div>
            {
                showModal && <RolesEdit setShowModal={setShowModal} refresh={refresh} />
            }
        </div>
    );
}

export default Roles;